var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.728 71.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #acbcbc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-basket",
    transform: "translate(0 -20.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(0 20.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-1",
    d: "M296.114,39.013h6.814l-10.1-17.33a2.939,2.939,0,1,0-5.074,2.968Z",
    transform: "translate(-241.492 -20.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-1",
    d: "M117.475,24.689a2.939,2.939,0,0,0-5.074-2.968L102.3,39.066h6.814Z",
    transform: "translate(-85.976 -20.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-1",
    d: "M72.718,171.278H4.995A4.992,4.992,0,0,0,0,176.273v5.537A4.992,4.992,0,0,0,4.995,186.8H6.558l4.819,26.122a6.844,6.844,0,0,0,6.335,5.521h41.3a6.844,6.844,0,0,0,6.335-5.521L70.2,186.789h2.537a4.992,4.992,0,0,0,4.995-4.995v-5.537A5.012,5.012,0,0,0,72.718,171.278ZM27.574,197.384V208.65a2.824,2.824,0,1,1-5.649,0v-15.8a2.824,2.824,0,1,1,5.649,0Zm9.064,0V208.65a2.824,2.824,0,1,1-5.649,0v-15.8a2.819,2.819,0,0,1,2.824-2.824,2.883,2.883,0,0,1,2.824,2.824Zm9.112,6.543v4.723a2.824,2.824,0,1,1-5.649,0v-15.8a2.883,2.883,0,0,1,2.824-2.824,2.819,2.819,0,0,1,2.824,2.824Zm9.064,0v4.723a2.824,2.824,0,1,1-5.649,0v-15.8a2.824,2.824,0,0,1,5.649,0Z",
    transform: "translate(0 -147.174)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropBasket);
export default __webpack_public_path__ + "static/media/drop_basket.731af840cee40ee41e16e3eda0edea11.svg";
export { ForwardRef as ReactComponent };